import {Component, input} from '@angular/core';
import {CardModule} from 'primeng/card';

@Component({
  selector: 'elcia-card',
  imports: [CardModule],
  templateUrl: './card.html',
  styleUrl: './card.scss'
})
export class ElciaCard {
  title = input<string>();
}
